const components = [
    { code: "Textbox", name: "Textbox" },
    { code: "Slider", name: "Slider" },
    { code: "Checkbox", name: "Checkbox" }
]

export const getComponentTypes = () => {
    return components;
}